const Resource = () => <h2>Resource Page</h2>;

export default Resource;
